import { Outlet } from "react-router-dom";
import { Layout } from "./components";
import { ThemeProvider } from "@mui/material/styles";
import { THEME } from "styles/theme";
import { StoreProvider } from "context/storeContext";

const App = () => {
  return (
    <ThemeProvider theme={THEME}>
      <StoreProvider>
        <Layout>
          <Outlet />
        </Layout>
      </StoreProvider>
    </ThemeProvider>
  );
};

export default App;
